import { Deserializable } from './deserializable';
import { ControlDevice } from './controlDevice';
import { ControlAction } from './controlAction';
import { PilomatSystemInfo } from './pilomatSystemInfo';
import { Log } from '../util/log';
import { DateHelper } from '../util/dateHelper';
import { DeviceState } from './deviceState';


export class DevicePilomat extends ControlDevice implements Deserializable {

  systemInfo: PilomatSystemInfo;
  actions: ControlAction[];

  selected: boolean;
  state: string;
  stateString: string = $localize`:@@device_access_model_device_state_loading:Caricamento...`;
  deviceOffline: boolean;
  errors: string = "";
  shortPermissions: string;
  phoneNumber: string;
  // icon: string = './assets/img/device/device_icon_uknown.png';
  icon: string = '';
  canBusEnabled: boolean;
  ioEthEnabled: boolean;
  licensePlateEnabled: boolean;

  badge1Enabled: boolean;
  badge2Enabled: boolean;
  pin1Enabled: boolean;
  pin2Enabled: boolean;
  phoneEnabled: boolean;
  remoteEnabled: boolean;
  appEnabled: boolean;
  watchDogTimeSec: number;
  watchDogEnabled: boolean = false;

  systemId: string;

  orderConfirmation: string;
  bollardInstallationDate: string;

  bollardSwVersion: string;
  bollardHwVersion: string;
  bollardSerial: string;
  fwVersion: number;

  routerSerial: string;

  forcedLow: boolean;
  synchronizing: boolean;

  forcedLowActive: boolean;
  forcedLowReason: string;

  dateFriendly: string;

  lastKnownState: DeviceState;
  vpnState: number = -1;
  // -1 = non presente | 0 = non connesso | 1 = connesso

  static STATE_TYPE_LOWERED: string = "Lowered";
  static STATE_TYPE_NOTLOWERED: string = "NotLowered";
  static STATE_TYPE_LIFTEDUP: string = "LiftedUp";
  static STATE_TYPE_OFFLINE: string = "Offline";
  static STATE_TYPE_ERROR: string = "Error";
  static STATE_TYPE_IOERROR: string = "IOLoweredNotConfigured";
  static STATE_TYPE_FORCEDLOW: string = "ForcedLow";

  static REASON_DISCONNECT: string = "disconnect-forcelow";
  static REASON_AUTOMATIC: string = "autom-forcelow";
  static REASON_MANUAL: string = "manual-forcelow";
  static MIN_VER_FORCEDLOW_REASON: number = 123;




  static TYPE: string[] = [
    DevicePilomat.STATE_TYPE_LOWERED,
    DevicePilomat.STATE_TYPE_NOTLOWERED,
    DevicePilomat.STATE_TYPE_LIFTEDUP,
    DevicePilomat.STATE_TYPE_OFFLINE,
    DevicePilomat.STATE_TYPE_ERROR,
    DevicePilomat.STATE_TYPE_IOERROR
  ];

  deserialize(input: any) {

    super.deserialize(input);
    Object.assign(this, input);

    //gesione momentanea per transizione al sistema nuovo
    if (this.state == "ForcedLow") {
      this.forcedLow = true;
    }

    this.systemInfo = new PilomatSystemInfo().deserialize(this.systemInfo);
    if (input.actions) {
      this.actions = this.actions.map(action => new ControlAction().deserialize(action));
    }
    this.selected = false;
    this.shortPermissions = "-";

    if (this.bollardInstallationDate) {
      this.dateFriendly = DateHelper.formatDateFriendly(new Date(this.bollardInstallationDate));
    }

    if (this.watchDogTimeSec) {
      if (this.watchDogTimeSec > 0) {
        this.watchDogEnabled = true;
      } else {
        this.watchDogEnabled = false;
      }
    } else {
      this.watchDogEnabled = false;
    }

    this.setDefaultNameIfNeeded();

    Log.debug("this.lastKnownState is : " + this.lastKnownState);

    return this;
  }


  public showErrorState() {
    this.state = DevicePilomat.STATE_TYPE_ERROR;
    this.updateIcon();
  }

  public updateState(deviceState) {

    if (deviceState) {

      Log.debug("devicePilomat.ts deviceState:");
      Log.debug(deviceState);

      this.state = deviceState.state;
      this.forcedLowActive = deviceState.forcedLowActive;
      this.forcedLowReason = deviceState.forcedLowReason;
      this.forcedLow = deviceState.forcedLow;

      this.synchronizing = deviceState.synchronizing;

      this.errors = "";
      if (deviceState.state == DevicePilomat.STATE_TYPE_LOWERED) {
        if (this.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_BOLLARD || this.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_ROADBLOCKER) {
          this.stateString = $localize`:@@device_access_model_device_state_lowered:Abbassato`;
        } else {
          this.stateString = $localize`:@@device_access_model_device_state_open:Aperto`;
        }

      } else if (deviceState.state == DevicePilomat.STATE_TYPE_NOTLOWERED) {
        if (this.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_BOLLARD || this.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_ROADBLOCKER) {
          this.stateString = $localize`:@@device_access_model_device_state_not_lowered:Non abbassato`;
        } else {
          this.stateString = $localize`:@@device_access_model_device_state_not_opened:Non aperto`;
        }
      } else if (deviceState.state == DevicePilomat.STATE_TYPE_LIFTEDUP) {

        if (this.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_BOLLARD || this.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_ROADBLOCKER) {
          this.stateString = $localize`:@@device_access_model_device_state_lifted_up:Alzato`;
        } else {
          this.stateString = $localize`:@@device_access_model_device_state_closed:Chiuso`;
        }

      } else if (deviceState.state == DevicePilomat.STATE_TYPE_ERROR) {
        this.stateString = $localize`:@@device_access_model_device_state_error:Errore`;
      } else if (deviceState.state == DevicePilomat.STATE_TYPE_OFFLINE) {
        this.deviceOffline = true;
        this.stateString = $localize`:@@device_access_model_device_state_offline:Offline`;
      }
      else if (deviceState.state == 'ForcedLow') {
        if (this.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_BOLLARD || this.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_ROADBLOCKER) {
          this.stateString = $localize`:@@device_access_model_device_state_forcedLow:Forzato Basso`;
          this.stateString = $localize`:@@device_access_model_device_state_forcedClosed:Forzato chiuso`;
        }
      }
      else if (deviceState.state == DevicePilomat.STATE_TYPE_IOERROR) {
        this.stateString = $localize`:@@device_access_model_device_state_io_error: Errore`;
        this.errors = $localize`:@@device_access_model_device_error_switch_not_configured:Contatto basso non configurato`;
      }

      if (this.forcedLow && !this.forcedLowActive) {
        if (this.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_BOLLARD || this.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_ROADBLOCKER) {
          this.stateString = this.stateString + $localize`:@@device_access_model_device_statestring_forcedLow:, forzato basso`;
        } else {
          this.stateString = this.stateString + $localize`:@@device_access_model_device_statestring_forcedClosed:, forzato aperto`;
        }
      }

      //       static REASON_DISCONNECT: string = "disconnect-forcelow";
      // static REASON_AUTOMATIC: string = "autom-forcelow";
      // static REASON_MANUAL: string = "manual-forcelow";

      if (this.systemInfo.version >= DevicePilomat.MIN_VER_FORCEDLOW_REASON) {
        if (this.forcedLowActive) {
          if (this.forcedLowReason == DevicePilomat.REASON_AUTOMATIC) {
            if (this.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_BOLLARD || this.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_ROADBLOCKER) {
              this.stateString = this.stateString + $localize`:@@device_access_model_device_statestring_forcedLow_automation:, forzato basso da automazione`;
            } else {
              this.stateString = this.stateString + $localize`:@@device_access_model_device_statestring_forcedClosed_automation:, forzato aperto da automazione`;
            }
          } else if (this.forcedLowReason == DevicePilomat.REASON_MANUAL) {
            if (this.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_BOLLARD || this.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_ROADBLOCKER) {
              this.stateString = this.stateString + $localize`:@@device_access_model_device_statestring_forcedLow_manual:, forzato basso manuale`;
              // this.forcedLowActive = false;
            } else {
              this.stateString = this.stateString + $localize`:@@device_access_model_device_statestring_forcedClosed_manual:, forzato aperto manuale`;
              // this.forcedLowActive = false;
            }
          }
          else if (this.forcedLowReason == DevicePilomat.REASON_DISCONNECT) {
            if (this.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_BOLLARD || this.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_ROADBLOCKER) {
              this.stateString = this.stateString + $localize`:@@device_access_model_device_statestring_forcedLow_disconnect:, forzato basso da disconnessione`;
            } else {
              this.stateString = this.stateString + $localize`:@@device_access_model_device_statestring_forcedClosed_disconnect:, forzato aperto da disconnessione`;
            }
          }

        }
      }

      this.updateIcon();
    }

  }

  setDefaultNameIfNeeded() {
    let noname = $localize`:@@device_access_model:Dispositivo senza nome`;

    if (!this.systemInfo.reference) {
      this.name = noname;
    } else if (this.systemInfo.reference == "") {
      this.name = noname;
    } else {
      this.name = this.systemInfo.reference;
    }
  }

  public updateIcon() {

    let iconString = "./assets/img/" + this.systemInfo.model + "/";

    if (this.selected) {
      iconString += "selected_";
    }

    if (this.forcedLow || this.forcedLowActive) {
      iconString += "forcedLow_";
    }

    if (this.state == DevicePilomat.STATE_TYPE_LIFTEDUP) {
      iconString += DevicePilomat.STATE_TYPE_NOTLOWERED;
    } else if (this.state == DevicePilomat.STATE_TYPE_IOERROR) {
      iconString += DevicePilomat.STATE_TYPE_ERROR;
    } else {
      iconString += this.state;
    }
    iconString += ".png"

    this.icon = iconString;
  }

  // public updateIcon() {

  //   if (this.selected) {
  //     if (this.forcedLow) {

  //       if (this.state == DevicePilomat.STATE_TYPE_LOWERED) {
  //         this.icon = './assets/img/device/device_icon_selected_forcedLow.png';
  //       } else if (this.state == DevicePilomat.STATE_TYPE_NOTLOWERED || this.state == DevicePilomat.STATE_TYPE_LIFTEDUP) {
  //         this.icon = './assets/img/device/device_icon_selected_forcedLow_notLowered.png';
  //       } else if (this.state == DevicePilomat.STATE_TYPE_OFFLINE) {
  //         this.icon = './assets/img/device/device_icon_selected_forcedLow_offline.png';
  //       }

  //       else if (this.state == DevicePilomat.STATE_TYPE_FORCEDLOW) {
  //         this.icon = './assets/img/device/device_icon_selected_forcedLow.png';
  //       }
  //       else {
  //         this.icon = './assets/img/device/device_icon_selected_forcedLow_error.png';
  //       }

  //     } else {

  //       if (this.state == DevicePilomat.STATE_TYPE_LOWERED) {
  //         this.icon = './assets/img/device/device_icon_selected_lowered.png';
  //       } else if (this.state == DevicePilomat.STATE_TYPE_NOTLOWERED || this.state == DevicePilomat.STATE_TYPE_LIFTEDUP) {
  //         this.icon = './assets/img/device/device_icon_selected_notLowered.png';
  //       } else if (this.state == DevicePilomat.STATE_TYPE_OFFLINE) {
  //         this.icon = './assets/img/device/device_icon_selected_offline.png';
  //       }

  //       else if (this.state == DevicePilomat.STATE_TYPE_FORCEDLOW) {
  //         this.icon = './assets/img/device/device_icon_selected_forcedLow.png';
  //       }

  //       else {
  //         this.icon = './assets/img/device/device_icon_selected_error.png';
  //       }

  //     }


  //   } else {

  //     if (this.forcedLow) {

  //       if (this.state == "Lowered") {
  //         this.icon = './assets/img/device/device_icon_forcedLow.png';
  //       } else if (this.state == DevicePilomat.STATE_TYPE_NOTLOWERED || this.state == DevicePilomat.STATE_TYPE_LIFTEDUP) {
  //         this.icon = './assets/img/device/device_icon_forcedLow_notLowered.png';
  //       } else if (this.state == DevicePilomat.STATE_TYPE_OFFLINE) {
  //         this.icon = './assets/img/device/device_icon_forcedLow_offline.png';
  //       }


  //       else if (this.state == DevicePilomat.STATE_TYPE_FORCEDLOW) {
  //         this.icon = './assets/img/device/device_icon_forcedLow.png';
  //       }

  //       else {
  //         this.icon = './assets/img/device/device_icon_forcedLow_error.png';
  //       }

  //     } else {

  //       if (this.state == "Lowered") {
  //         this.icon = './assets/img/device/device_icon_lowered.png';
  //       } else if (this.state == DevicePilomat.STATE_TYPE_NOTLOWERED || this.state == DevicePilomat.STATE_TYPE_LIFTEDUP) {
  //         this.icon = './assets/img/device/device_icon_notLowered.png';
  //       } else if (this.state == DevicePilomat.STATE_TYPE_OFFLINE) {
  //         this.icon = './assets/img/device/device_icon_offline.png';
  //       }

  //       else if (this.state == DevicePilomat.STATE_TYPE_FORCEDLOW) {
  //         this.icon = './assets/img/device/device_icon_forcedLow.png';
  //       }


  //       else {
  //         this.icon = './assets/img/device/device_icon_error.png';
  //       }


  //     }
  //   }
  // }
}
